import React, { useEffect, useRef, useState } from 'react';

const Specification = ({ selectedType }) => {
    const sections = {
        "Designer Suite": [
            {
                category: "Gourmet Kitchen",
                categoryDetails: [
                    { title: "Counter Top ", description: "Granite - Anti bacterial - Matt Black finish" },
                    { title: "Under mount kitchen sink", description: "Matt black finish" },
                    { title: "Faucet and Soap Dispenser", description: "Matt Black Finish" },
                    { title: "Disposal", description: "Pull out trash Can Under Cabinet" },
                    { title: "Flooring", description: "Stone finish tiles " },
                    { title: "Drainage System", description: "Anti-odor and pest-resistant" },
                    { title: "Ventilation System", description: "Centralized ecology system with odor and intoxicant control" },
                    { title: "Cabinerty", description: "Custom design" },
                    { title: "Type C Socket ", description: "yes" },
                ],

            },
            {
                category: "Kitchen Appliances",
                categoryDetails: [
                    { title: "Built-in Fridge", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Gas Hob", brand: "(Miele)", description: "Yes" },
                    { title: "Hood", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Microwave", brand: "(Miele )", description: "Yes" },
                    { title: "Lighting", description: "Energy Efficient LED" },
                ],
            },
            {
                category: "Bespoke Bathrooms and Powder Room",
                categoryDetails: [
                    { title: "Flooring", description: "Stone finish tiles " },
                    { title: "Sanitary Fitting", description: "Brass base finished in chrome" },
                    { title: "Smart Mirror", description: "Mobile integrated via Bluetooth " },
                    { title: "Exhaust System", description: "Anti fogger" },
                    { title: "Water Flush Tank", brand: "(Geibret)", description: "Water efficient flush tanks" },
                    { title: "Shower Head", description: "Rain shower" },
                    { title: "Soap Dispenser", description: "Stainless steel modern design soap dispensers" },
                    { title: "Shower drains", description: "Linear shower drains" },
                    { title: "Water Heater", description: "Yes" },
                    { title: "Vanities", description: "Korean material - Bespoke design" },
                ],

            },
            {
                category: "Living Area",
                categoryDetails: [
                    { title: "Ceiling Height", description: "3.2M" },
                    { title: "Smart Door Bell", brand: "(Ring)", description: "Yes " },
                    { title: "Thermostat - Installed in all rooms", description: "Google Nest " },
                    { title: "Floor to ceiling windows", description: "Highly performance  - Protection from UV & IR - Sound & temperature controlled  " },
                    { title: "Indoor Air Quality ", description: "Fresh Air Handling Units - FAHU" },
                    { title: "Door Stopper ", description: "Yes" },
                    { title: "Main Door Lock ", description: "Smart lock system " },
                    { title: "Type C Sockets", description: "Yes" },
                    { title: "Wardrobe", description: "Custom design" },
                    { title: "Balcony", description: "Yes" },
                ],


            },
            {
                category: "Amenities",
                categoryDetails: [
                    { title: "Swimming Pool", description: "3 swimming pools" },
                    { title: "GYM (indoor)", brand: "(Technogym)", description: "Yes" },
                    { title: "GYM (outdoor)", description: "Yes" },
                    { title: "Coffee Lounge ", brand: "(Topbrewer by Scanomat)", description: "Yes" },
                    { title: "Pet Friendly ", description: "Yes" },
                    { title: "Architecture and design ", description: "Contemporary Design | Sleek | Transparent Feel | Lit Sculpture at Night" },
                    { title: "Service Charges ", description: "To be determined by RERA" },
                    { title: "Covered Car Parking", description: "One per unit" },
                    { title: "Fragrance Machines", description: " 24/7 Fragrance in reception & lift lobbies" },
                    { title: "Hand driers", brand: "(Dyson Blades)", description: "Modern design & power efficient hand driers" },
                    { title: "Gallet Benches", description: "Modern design gallet benches in courtyard" },
                    { title: "Dustbins", brand: "(Simple human)", description: "Smart dustbin | Sensored operated | No touch mechanism" },
                    { title: "Smart Intercom", description: "Yes" },
                    { title: "Solar Panels", description: "For common area" },
                    { title: "Landscaping & Plantation", description: "Yes" },
                    { title: "Parking Barriers", description: "Automatic via RFID" },
                ],


            },
            {
                category: "Utility Connection",
                categoryDetails: [
                    { title: "DEWA", description: "Yes" },
                    { title: "LPG", brand: "(Lootah Gas)", description: "Yes" },
                    { title: "Central Cooling System", brand: "(Empower)", description: "Yes" },
                ],

            },
        ],
        "Townhouse": [
            {
                category: "Gourmet Kitchen",
                categoryDetails: [
                    { title: "Kitchen Island & Counter Top  ", description: "Granite - Anti bacterial - Matt Black finish" },
                    { title: "Under mount kitchen sink", description: "Matt black finish" },
                    { title: "Faucet and Soap Dispenser", description: "Matt Black Finish" },
                    { title: "Disposal", description: "Pull out trash Can Under Cabinet" },
                    { title: "Flooring", description: "Stone finish tiles " },
                    { title: "Drainage System", description: "Anti-odor and pest-resistant" },
                    { title: "Ventilation System", description: "Centralized ecology system with odor and intoxicant control" },
                    { title: "Cabinerty", description: "Custom design" },
                    { title: "Type C Socket ", description: "yes" },
                ],

            },
            {
                category: "Kitchen Appliances",
                categoryDetails: [
                    { title: "Built-in Fridge", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Oven  ", brand: "(Miele)", description: "Yes" },
                    { title: "Gas Hob", brand: "(Miele)", description: "Yes" },
                    { title: "Hood", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Dishwasher ", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Microwave", brand: "(Miele  )", description: "Yes" },
                    { title: "Lighting", description: "Energy Efficient LED" },
                ],
            },
            {
                category: "Bespoke Bathrooms and Powder Room",
                categoryDetails: [
                    { title: "Flooring", description: "Stone finish tiles " },
                    { title: "Sanitary Fitting", description: "Brass base finished in chrome" },
                    { title: "Mirror", description: "Integrated energy efficient LED Light " },
                    { title: "Smart Mirror", description: "Mobile integrated via Bluetooth " },
                    { title: "Exhaust System", description: "Anti fogger" },
                    { title: "Water Flush Tank", brand: "(Geibret)", description: "Water efficient flush tanks" },
                    { title: "Shower Head", description: "Rain shower" },
                    { title: "Soap Dispenser", description: "Stainless steel modern design soap dispensers" },
                    { title: "Shower drains", description: "Linear shower drains" },
                    { title: "Water Heater", description: "Yes" },
                    { title: "Vanities", description: "Korean material - Bespoke design" },
                ],

            },
            {
                category: "Living Area",
                categoryDetails: [
                    { title: "Ceiling Height", description: "3.2M" },
                    { title: "Smart Door Bell", brand: "(Ring)", description: "Yes " },
                ],


            },
            {
                category: "Master Bedroom and Secondary Bedroom",
                categoryDetails: [
                    { title: "Flooring", description: "Swiss Wood Flooring  " },
                    { title: "Thermostat - Installed in all rooms", description: "Google Nest " },
                    { title: "Floor to ceiling windows", description: "Highly performance  - Protection from UV & IR - Sound & temperature controlled   " },
                    { title: "Indoor Air Quality ", description: "Fresh Air Handling Units - FAHU " },
                    { title: "Door Stopper ", description: "Yes" },
                    { title: "Main Door Lock ", description: "Smart lock system " },
                    { title: "Type C Sockets", description: "Yes " },
                    { title: "Wardrobe / Walk-in Closet", description: "Custom Designed" },
                    { title: "Private Infinity Pool", description: "Yes | Walk in Pool" },
                    { title: "Balcony", description: "Yes" },
                ],

            },
            {
                category: "Amenities",
                categoryDetails: [
                    { title: "Swimming Pool", description: "3 swimming pools" },
                    { title: "GYM (indoor)", brand: "(Technogym)", description: "Yes" },
                    { title: "GYM (outdoor)", description: "Yes" },
                    { title: "Coffee Lounge ", brand: "(Topbrewer by Scanomat)", description: "Yes" },
                    { title: "Pet Friendly ", description: "Yes" },
                    { title: "Architecture and design ", description: "Contemporary Design | Sleek | Transparent Feel | Lit Sculpture at Night" },
                    { title: "Service Charges ", description: "To be determined by RERA" },
                    { title: "Covered Car Parking", description: "One per unit" },
                    { title: "Fragrance Machines", description: " 24/7 Fragrance in reception & lift lobbies" },
                    { title: "Hand driers", brand: "(Dyson Blades)", description: "Modern design & power efficient hand driers" },
                    { title: "Gallet Benches", description: "Modern design gallet benches in courtyard" },
                    { title: "Dustbins", brand: "(Simple human)", description: "Smart dustbin | Sensored operated | No touch mechanism" },
                    { title: "Smart Intercom", description: "Yes" },
                    { title: "Main Door Lock ", description: "Smart lock system " },
                    { title: "Landscaping & Plantation", description: "Yes" },
                    { title: "Parking Barriers", description: "Automatic via RFID" },
                ],


            },
            {
                category: "Utility Connection",
                categoryDetails: [
                    { title: "DEWA", description: "Yes" },
                    { title: "LPG", brand: "(Lootah Gas)", description: "Yes" },
                    { title: "Central Cooling System", brand: "(Empower)", description: "Yes" },
                ],

            },
        ],
        "1BD Penthouses": [
            {
                category: "Gourmet Kitchen",
                categoryDetails: [
                    { title: "Kitchen Island & Counter Top  ", description: "Granite - Anti bacterial - Matt Black finish" },
                    { title: "Under mount kitchen sink", description: "Matt black finish" },
                    { title: "Faucet and Soap Dispenser", description: "Matt Black Finish" },
                    { title: "Disposal", description: "Pull out trash Can Under Cabinet" },
                    { title: "Flooring", description: "Stone finish tiles " },
                    { title: "Drainage System", description: "Anti-odor and pest-resistant" },
                    { title: "Ventilation System", description: "Centralized ecology system with odor and intoxicant control" },
                    { title: "Cabinerty", description: "Custom design" },
                    { title: "Type C Socket ", description: "yes" },
                ],

            },
            {
                category: "Kitchen Appliances",
                categoryDetails: [
                    { title: "Built-in Fridge", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Oven  ", brand: "(Miele)", description: "Yes" },
                    { title: "Gas Hob", brand: "(Miele)", description: "Yes" },
                    { title: "Hood", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Dishwasher ", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Microwave", brand: "(Miele )", description: "Yes" },
                    { title: "Lighting", description: "Energy Efficient LED" },
                ],
            },
            {
                category: "Bespoke Bathrooms and Powder Room",
                categoryDetails: [
                    { title: "Flooring", description: "Stone finish tiles " },
                    { title: "Sanitary Fitting", description: "Brass base finished in chrome" },
                    { title: "Mirror", description: "Integrated energy efficient LED Light " },
                    { title: "Smart Mirror", description: "Mobile integrated via Bluetooth " },
                    { title: "Exhaust System", description: "Anti fogger" },
                    { title: "Water Flush Tank", brand: "(Geibret)", description: "Water efficient flush tanks" },
                    { title: "Shower Head", description: "Rain shower" },
                    { title: "Soap Dispenser", description: "Stainless steel modern design soap dispensers" },
                    { title: "Shower drains", description: "Linear shower drains" },
                    { title: "Water Heater", description: "Yes" },
                    { title: "Vanities", description: "Korean material - Bespoke design" },
                ],

            },
            {
                category: "Living Area",
                categoryDetails: [
                    { title: "Double Height Ceiling ", description: "7M" },
                    { title: "Smart Door Bell", brand: "(Ring)", description: "Yes " },
                    { title: "Stairs Steps", description: "Marble steps | Duplex Units" },
                ],


            },
            {
                category: "Master Bedroom and Secondary Bedroom",
                categoryDetails: [
                    { title: "Flooring", description: "Swiss Wood Flooring  " },
                    { title: "Thermostat - Installed in all rooms", description: "Google Nest " },
                    { title: "Floor to ceiling windows", description: "Highly performance  - Protection from UV & IR - Sound & temperature controlled   " },
                    { title: "Indoor Air Quality ", description: "Fresh Air Handling Units - FAHU " },
                    { title: "Door Stopper ", description: "Yes" },
                    { title: "Type C Sockets", description: "Yes " },
                    { title: "Wardrobe / Walk-in Closet", description: "Custom Designed" },
                    { title: "Private Infinity Pool", description: "In Exclusive Units" },
                    { title: "Balcony", description: "Yes" },
                ],

            },
            {
                category: "Amenities",
                categoryDetails: [
                    { title: "Swimming Pool", description: "3 swimming pools" },
                    { title: "GYM (indoor)", brand: "(Technogym)", description: "Yes" },
                    { title: "GYM (outdoor)", description: "Yes" },
                    { title: "Coffee Lounge ", brand: "(Topbrewer by Scanomat)", description: "Yes" },
                    { title: "Pet Friendly ", description: "Yes" },
                    { title: "Architecture and design ", description: "Contemporary Design | Sleek | Transparent Feel | Lit Sculpture at Night" },
                    { title: "Service Charges ", description: "To be determined by RERA" },
                    { title: "Covered Car Parking", description: "One per unit" },
                    { title: "Fragrance Machines", description: " 24/7 Fragrance in reception & lift lobbies" },
                    { title: "Hand driers", brand: "(Dyson Blades)", description: "Modern design & power efficient hand driers" },
                    { title: "Gallet Benches", description: "Modern design gallet benches in courtyard" },
                    { title: "Dustbins", brand: "(Simple human)", description: "Smart dustbin | Sensored operated | No touch mechanism" },
                    { title: "Smart Intercom", description: "Yes" },
                    { title: "Main Door Lock ", description: "Smart lock system " },
                    { title: "Landscaping & Plantation", description: "Yes" },
                    { title: "Parking Barriers", description: "Automatic via RFID" },
                ],


            },
            {
                category: "Utility Connection",
                categoryDetails: [
                    { title: "DEWA", description: "Yes" },
                    { title: "LPG", brand: "(Lootah Gas)", description: "Yes" },
                    { title: "Central Cooling System", brand: "(Empower)", description: "Yes" },
                ],

            },
        ],
        "2BD Penthouses": [
            {
                category: "Gourmet Kitchen",
                categoryDetails: [
                    { title: "Kitchen Island & Counter Top ", description: "Granite - Anti bacterial - Matt Black finish" },
                    { title: "Under mount kitchen sink", description: "Matt black finish" },
                    { title: "Faucet and Soap Dispenser", description: "Matt Black Finish" },
                    { title: "Disposal", description: "Pull out trash Can Under Cabinet" },
                    { title: "Flooring", description: "Stone finish tiles " },
                    { title: "Drainage System", description: "Anti-odor and pest-resistant" },
                    { title: "Ventilation System", description: "Centralized ecology system with odor and intoxicant control" },
                    { title: "Cabinerty", description: "Custom design" },
                    { title: "Type C Socket ", description: "yes" },
                ],

            },
            {
                category: "Kitchen Appliances",
                categoryDetails: [
                    { title: "Built-in Fridge", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Oven  ", brand: "(Miele)", description: "Yes" },
                    { title: "Gas Hob", brand: "(Miele)", description: "Yes" },
                    { title: "Hood", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Dishwasher ", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Microwave", brand: "(Miele  )", description: "Yes" },
                    { title: "Lighting", description: "Energy Efficient LED" },
                ],
            },
            {
                category: "Bespoke Bathrooms and Powder Room",
                categoryDetails: [
                    { title: "Flooring", description: "Stone finish tiles " },
                    { title: "Sanitary Fitting", description: "Brass base finished in chrome" },
                    { title: "Mirror", description: "Integrated energy efficient LED Light " },
                    { title: "Smart Mirror", description: "Mobile integrated via Bluetooth " },
                    { title: "Exhaust System", description: "Anti fogger" },
                    { title: "Water Flush Tank", brand: "(Geibret)", description: "Water efficient flush tanks" },
                    { title: "Shower Head", description: "Rain shower" },
                    { title: "Soap Dispenser", description: "Stainless steel modern design soap dispensers" },
                    { title: "Shower drains", description: "Linear shower drains" },
                    { title: "Water Heater", description: "Yes" },
                    { title: "Vanities", description: "Korean material - Bespoke design" },
                ],

            },
            {
                category: "Living Area",
                categoryDetails: [
                    { title: "Height ceiling ", description: "3.2M" },
                    { title: "Smart Door Bell", brand: "(Ring)", description: "Yes " },

                ],


            },
            {
                category: "Master Bedroom and Secondary Bedroom",
                categoryDetails: [
                    { title: "Flooring", description: "Swiss Wood Flooring  " },
                    { title: "Thermostat - Installed in all rooms", description: "Google Nest " },
                    { title: "Floor to ceiling windows", description: "Highly performance  - Protection from UV & IR - Sound & temperature controlled   " },
                    { title: "Indoor Air Quality ", description: "Fresh Air Handling Units - FAHU " },
                    { title: "Door Stopper ", description: "Yes" },
                    { title: "Type C Sockets", description: "Yes " },
                    { title: "Main Door Lock ", description: "Smart lock system  " },
                    { title: "Wardrobe / Walk-in Closet", description: "Custom Designed" },
                    { title: "Private Infinity Pool", description: "In Exclusive Units" },
                    { title: "Balcony", description: "Yes" },
                ],

            },
            {
                category: "Amenities",
                categoryDetails: [
                    { title: "Swimming Pool", description: "3 swimming pools" },
                    { title: "GYM (indoor)", brand: "(Technogym)", description: "Yes" },
                    { title: "GYM (outdoor)", description: "Yes" },
                    { title: "Coffee Lounge ", brand: "(Topbrewer by Scanomat)", description: "Yes" },
                    { title: "Pet Friendly ", description: "Yes" },
                    { title: "Architecture and design ", description: "Contemporary Design | Sleek | Transparent Feel | Lit Sculpture at Night" },
                    { title: "Service Charges ", description: "To be determined by RERA" },
                    { title: "Covered Car Parking", description: "One per unit" },
                    { title: "Fragrance Machines", description: " 24/7 Fragrance in reception & lift lobbies" },
                    { title: "Hand driers", brand: "(Dyson Blades)", description: "Modern design & power efficient hand driers" },
                    { title: "Gallet Benches", description: "Modern design gallet benches in courtyard" },
                    { title: "Dustbins", brand: "(Simple human)", description: "Smart dustbin | Sensored operated | No touch mechanism" },
                    { title: "Smart Intercom", description: "Yes" },
                    { title: "Main Door Lock ", description: "Smart lock system " },
                    { title: "Landscaping & Plantation", description: "Yes" },
                    { title: "Parking Barriers", description: "Automatic via RFID" },
                ],


            },
            {
                category: "Utility Connection",
                categoryDetails: [
                    { title: "DEWA", description: "Yes" },
                    { title: "LPG", brand: "(Lootah Gas)", description: "Yes" },
                    { title: "Central Cooling System", brand: "(Empower)", description: "Yes" },
                ],

            },
        ],
        "Sky Villas": [
            {
                category: "Gourmet Kitchen",
                categoryDetails: [
                    { title: "Kitchen Island & Counter Top ", description: "Granite - Anti bacterial - Matt Black finish" },
                    { title: "Under mount kitchen sink", description: "Matt black finish" },
                    { title: "Faucet and Soap Dispenser", description: "Matt Black Finish" },
                    { title: "Disposal", description: "Pull out trash Can Under Cabinet" },
                    { title: "Flooring", description: "Stone finish tiles " },
                    { title: "Drainage System", description: "Anti-odor and pest-resistant" },
                    { title: "Ventilation System", description: "Centralized ecology system with odor and intoxicant control" },
                    { title: "Cabinerty", description: "Custom design" },
                    { title: "Type C Socket ", description: "yes" },
                ],

            },
            {
                category: "Kitchen Appliances",
                categoryDetails: [
                    { title: "Built-in Fridge", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Oven  ", brand: "(Miele)", description: "Yes" },
                    { title: "Gas Hob", brand: "(Miele)", description: "Yes" },
                    { title: "Hood", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Dishwasher ", brand: "(Equal Or Better)", description: "Yes" },
                    { title: "Built-in Microwave", brand: "(Miele  )", description: "Yes" },
                    { title: "Lighting", description: "Energy Efficient LED" },
                ],
            },
            {
                category: "Bespoke Bathrooms and Powder Room",
                categoryDetails: [
                    { title: "Flooring", description: "Stone finish tiles " },
                    { title: "Sanitary Fitting", description: "Brass base finished in chrome" },
                    { title: "Mirror", description: "Integrated energy efficient LED Light " },
                    { title: "Smart Mirror", description: "Mobile integrated via Bluetooth " },
                    { title: "Exhaust System", description: "Anti fogger" },
                    { title: "Water Flush Tank", brand: "(Geibret)", description: "Water efficient flush tanks" },
                    { title: "Shower Head", description: "Rain shower" },
                    { title: "Soap Dispenser", description: "Stainless steel modern design soap dispensers" },
                    { title: "Shower drains", description: "Linear shower drains" },
                    { title: "Water Heater", description: "Yes" },
                    { title: "Vanities", description: "Korean material - Bespoke design" },
                ],

            },
            {
                category: "Living Area",
                categoryDetails: [
                    { title: "Height ceiling ", description: "7 M" },
                    { title: "Smart Door Bell", brand: "(Ring)", description: "Yes " },
                    { title: "Stairs Steps", description: "Marble Steps | Duplex Units " },

                ],


            },
            {
                category: "Master Bedroom and Secondary Bedroom",
                categoryDetails: [
                    { title: "Flooring", description: "Swiss Wood Flooring  " },
                    { title: "Thermostat - Installed in all rooms", description: "Google Nest " },
                    { title: "Floor to ceiling windows", description: "Highly performance  - Protection from UV & IR - Sound & temperature controlled   " },
                    { title: "Indoor Air Quality ", description: "Fresh Air Handling Units - FAHU " },
                    { title: "Door Stopper ", description: "Yes" },
                    { title: "Type C Sockets", description: "Yes " },
                    { title: "Wardrobe / Walk-in Closet", description: "Custom Designed" },
                    { title: "Private Infinity Pool", description: "In Exclusive Units" },
                    { title: "Balcony", description: "Yes" },
                    { title: "Main Door Lock ", description: "Smart lock system " },
                ],

            },
            {
                category: "Amenities",
                categoryDetails: [
                    { title: "Swimming Pool", description: "3 swimming pools" },
                    { title: "GYM (indoor)", brand: "(Technogym)", description: "Yes" },
                    { title: "GYM (outdoor)", description: "Yes" },
                    { title: "Coffee Lounge ", brand: "(Topbrewer by Scanomat)", description: "Yes" },
                    { title: "Pet Friendly ", description: "Yes" },
                    { title: "Architecture and design ", description: "Contemporary Design | Sleek | Transparent Feel | Lit Sculpture at Night" },
                    { title: "Service Charges ", description: "To be determined by RERA" },
                    { title: "Covered Car Parking", description: "One per unit" },
                    { title: "Fragrance Machines", description: " 24/7 Fragrance in reception & lift lobbies" },
                    { title: "Hand driers", brand: "(Dyson Blades)", description: "Modern design & power efficient hand driers" },
                    { title: "Gallet Benches", description: "Modern design gallet benches in courtyard" },
                    { title: "Dustbins", brand: "(Simple human)", description: "Smart dustbin | Sensored operated | No touch mechanism" },
                    { title: "Smart Intercom", description: "Yes" },
                    { title: "Main Door Lock ", description: "Smart lock system " },
                    { title: "Landscaping & Plantation", description: "Yes" },
                    { title: "Parking Barriers", description: "Automatic via RFID" },
                ],


            },
            {
                category: "Utility Connection",
                categoryDetails: [
                    { title: "DEWA", description: "Yes" },
                    { title: "LPG", brand: "(Lootah Gas)", description: "Yes" },
                    { title: "Central Cooling System", brand: "(Empower)", description: "Yes" },
                ],

            },
        ],


    };


    const [selectedSectionIndex, setSelectedSectionIndex] = useState(0);
    const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);

    const sectionRef = useRef(null);

    const currentTypeSections = sections[selectedType] || [];
    const currentCategory = currentTypeSections[selectedCategoryIndex] || {};

    const allCategoryDetails = currentCategory.categoryDetails || [];
    const itemsPerGroup = Math.ceil(allCategoryDetails.length / 3);
    const group1 = allCategoryDetails.slice(0, itemsPerGroup);
    const group2 = allCategoryDetails.slice(itemsPerGroup, itemsPerGroup * 2);
    const group3 = allCategoryDetails.slice(itemsPerGroup * 2);

    useEffect(() => {
        setSelectedCategoryIndex(0);
    }, [selectedType]);

    const handleArrowClick = (direction) => {
        let newCategoryIndex = selectedCategoryIndex;
        if (direction === "left") {
            newCategoryIndex = (selectedCategoryIndex - 1 + currentTypeSections.length) % currentTypeSections.length;
        } else {
            newCategoryIndex = (selectedCategoryIndex + 1) % currentTypeSections.length;
        }
        setSelectedCategoryIndex(newCategoryIndex);

        // Scroll to the section title
        sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    if (!currentTypeSections.length) {
        return <div>No specifications available for the selected type.</div>;
    }

    return (
        <div className='specification-main-div'>
            <div className='container'>
                <div className='main-content-div' ref={sectionRef}>
                    {/* Header */}
                    <div className='specification-header-content'>
                        <div className='specification-text'>
                            <h4>Specifications - {selectedType}</h4>
                        </div>
                        <div className='specification-number'>
                            <h3>{currentCategory?.category || "No Category"}</h3>
                            <h3>{String(selectedCategoryIndex + 1).padStart(2, '0')}</h3>
                        </div>
                    </div>

                    {/* Body Content */}
                    <div className='specification-body-content'>
                        <div className='body-content-1'>
                            {group1.map((detail, index) => (
                                <div key={index} className='content'>
                                    <p className='body-1-font'>{detail.title}
                                        <span>{detail.brand}</span>
                                    </p>
                                    <p className='body-2-font'>{detail.description}</p>
                                </div>
                            ))}
                        </div>
                        <div className='body-content-2'>
                            {group2.map((detail, index) => (
                                <div key={index} className='content'>
                                    <p className='body-1-font'>{detail.title}
                                        <span>{detail.brand}</span>
                                    </p>
                                    <p className='body-2-font'>{detail.description}</p>
                                </div>
                            ))}
                        </div>
                        <div className='body-content-3'>
                            {group3.map((detail, index) => (
                                <div key={index} className='content'>
                                    <p className='body-1-font'>{detail.title}
                                        <span>{detail.brand}</span>
                                    </p>
                                    <p className='body-2-font'>{detail.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Navigation Arrows */}
                    <div className='arrows-div-specification'>
                        <div className='arrows-div-left'>
                            <svg
                                onClick={() => handleArrowClick("left")}
                                xmlns="http://www.w3.org/2000/svg"
                                width="23"
                                height="16"
                                viewBox="0 0 23 16"
                                fill="none"
                            >
                                <path d="M22 9C22.5523 9 23 8.55228 23 8C23 7.44772 22.5523 7 22 7L22 9ZM0.292892 7.29289C-0.0976317 7.68342 -0.0976312 8.31658 0.292893 8.70711L6.65686 15.0711C7.04738 15.4616 7.68055 15.4616 8.07107 15.0711C8.4616 14.6805 8.4616 14.0474 8.07107 13.6569L2.41421 8L8.07106 2.34315C8.46159 1.95262 8.46159 1.31946 8.07106 0.928932C7.68054 0.538408 7.04737 0.538408 6.65685 0.928932L0.292892 7.29289ZM22 7L0.999999 7L1 9L22 9L22 7Z" fill="#C8AA8E" />
                            </svg>
                        </div>
                        <div className='arrows-div-right'>
                            <svg
                                onClick={() => handleArrowClick("right")}
                                xmlns="http://www.w3.org/2000/svg"
                                width="23"
                                height="16"
                                viewBox="0 0 23 16"
                                fill="none"
                            >
                                <path d="M0.999999 9C0.447714 9 -4.08979e-07 8.55228 0 8C4.08979e-07 7.44772 0.447716 7 1 7L0.999999 9ZM22.7071 7.29289C23.0976 7.68342 23.0976 8.31658 22.7071 8.70711L16.3431 15.0711C15.9526 15.4616 15.3195 15.4616 14.9289 15.0711C14.5384 14.6805 14.5384 14.0474 14.9289 13.6569L20.5858 8L14.9289 2.34315C14.5384 1.95262 14.5384 1.31946 14.9289 0.928932C15.3195 0.538408 15.9526 0.538408 16.3432 0.928932L22.7071 7.29289ZM1 7L22 7L22 9L0.999999 9L1 7Z" fill="#C8AA8E" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Specification;
